
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import demoContentHeading from '@ecl/eu-specs-typography/demo/data--heading';
import demoContentParagraph from '@ecl/eu-specs-typography/demo/data--paragraph';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Headings`}</h2>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="heading" mdxType="Playground">
  <h1 className="ecl-u-type-heading-1">{demoContentHeading.content}</h1>
  <h2 className="ecl-u-type-heading-2">{demoContentHeading.content}</h2>
  <h3 className="ecl-u-type-heading-3">{demoContentHeading.content}</h3>
  <h4 className="ecl-u-type-heading-4">{demoContentHeading.content}</h4>
  <h5 className="ecl-u-type-heading-5">{demoContentHeading.content}</h5>
    </Playground>
    <h2>{`Paragraph`}</h2>
    <h3>{`Lead paragraph`}</h3>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="paragraph" mdxType="Playground">
  <p className="ecl-u-type-paragraph-lead">{demoContentParagraph.content}</p>
    </Playground>
    <h3>{`Medium paragraph`}</h3>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="paragraph" mdxType="Playground">
  <p className="ecl-u-type-paragraph">{demoContentParagraph.content}</p>
    </Playground>
    <h3>{`Small paragraph`}</h3>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="paragraph" mdxType="Playground">
  <p className="ecl-u-type-paragraph-s">{demoContentParagraph.content}</p>
    </Playground>
    <h3>{`Extra small paragraph`}</h3>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="paragraph" mdxType="Playground">
  <p className="ecl-u-type-paragraph-xs">{demoContentParagraph.content}</p>
    </Playground>
    <h2>{`Text colour`}</h2>
    <p>{`Note: this list is not exhaustive, please read the usage page to know available colours.`}</p>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="text-colour" mdxType="Playground">
  <div className="ecl-u-type-m ecl-u-type-color-grey">Colour grey</div>
  <div className="ecl-u-type-m ecl-u-type-color-blue-120">Colour blue 120</div>
  <div className="ecl-u-type-m ecl-u-type-color-grey-75">Colour grey 75</div>
  <div className="ecl-u-type-m ecl-u-type-color-red">Colour red</div>
  <div className="ecl-u-type-m ecl-u-type-color-green">Colour green</div>
    </Playground>
    <h2>{`Text style`}</h2>
    <Playground system="eu" selectedKind="utilities-typography" selectedStory="text-style" mdxType="Playground">
  <div className="ecl-u-type-m ecl-u-type-none">
    {demoContentHeading.content}
  </div>
  <div className="ecl-u-type-m ecl-u-type-lowercase">
    {demoContentHeading.content}
  </div>
  <div className="ecl-u-type-m ecl-u-type-uppercase">
    {demoContentHeading.content}
  </div>
  <div className="ecl-u-type-m ecl-u-type-capitalize">
    {demoContentHeading.content}
  </div>
  <div className="ecl-u-type-m ecl-u-type-overline">
    {demoContentHeading.content}
  </div>
  <div className="ecl-u-type-m ecl-u-type-underline">
    {demoContentHeading.content}
  </div>
  <div className="ecl-u-type-m ecl-u-type-strike">
    {demoContentHeading.content}
  </div>
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;